let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5lvho")).then(() => parcelRequire('h188A'));